module.exports = __webpack_public_path__ + "static/media/auto.3a66d58a.jpg";